import React from "react";
import { Button, Col, Form, Input, Row, Tabs, message } from "antd";
import Script from 'react-load-script';
import { DownloadOutlined, LockOutlined, UserOutlined, SafetyOutlined } from '@ant-design/icons';
import img01 from "../../assets/img/login-img.png";

import BaseComponent from "../../redare/components/BaseComponent";
import logo from "../../assets/img/logo.png";
import WebWorkbenchPresenter from "../../.gen/presenter/WebWorkbenchPresenter";
import { Link } from "react-router-dom";
import Window from "../../redare/components/modal/Window";
import VerificationForm from "../../components/login/VerificationForm";
import LoginPresenter from "../../.gen/presenter/LoginPresenter";


export default class LoginPage extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            time: 60,
            loading: false,
            img: ""
        };
        this.presenter = new WebWorkbenchPresenter(this);
        this.loginPresenter = new LoginPresenter(this);
        const decodeUrl = (obj) => {
            let url = decodeURIComponent(obj);
            let firstQuestionMarkIndex = url.indexOf('?');
            let newUrl = url.substring(0, firstQuestionMarkIndex + 1) + url.substring(firstQuestionMarkIndex + 1).replace(/\?/g, '&');
            if (newUrl.indexOf('%') > 0) {
                return decodeUrl(newUrl);
            } else {
                return newUrl
            }
        }

        let url = decodeUrl(window.location.href);
        let code = new URL(`${url}`).searchParams.get('code');

        if (code) {
            this.presenter.wxLogin({ code, businessCode: "sso" }, res => {
                if (res.code == 0) {
                    this.setState({
                        openid: res.data.openid,
                        wxpcAccessToken: res.data.wxpcAccessToken,
                        token: !res.data.token || res.data.token == '' ? undefined : res.data.token
                    });
                    if (res.data.token) {
                        window.location.href = window._ctx + "/";
                    }
                }
            })
        }
    }

    getCookie(name) {
        const cookies = document.cookie.split(";"); // 将所有cookie拆分成一个数组
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            const cookieName = cookie.substring(0, name.length);
            if (cookieName === name) {
                return decodeURIComponent(cookie.substring(name.length + 1, cookie.length));
            }
        }
        return null; // 如果找不到对应的cookie，则返回null
    }
    _onSubmit() {
        this.form.validateFields().then(values => {
            this.setBtnLoading(true);
            if (!this.state.token) {
                values.openid = this.state.openid;
                values.wxpcAccessToken = this.state.wxpcAccessToken;
            }
            values.rancode = this.state.img.rancode;
            this.presenter.login({ ...values },
                res => {
                    console.log(res);

                    this.setBtnLoading(false);
                    let { sso, backUrl } = this._urlQuery;
                    if (!this.state.token && this.state.wxpcAccessToken && this.state.openid) {
                        this.presenter.wxBind({
                            wxpcAccessToken: this.state.wxpcAccessToken,
                            openid: this.state.openid,
                            sso_token: this.getCookie("sso_token")
                        }, res => {
                            if (res.code == 0) {
                                if (backUrl) {
                                    if (sso) {
                                        window.location.href = `${window._ctx}/ssowebserver/?backUrl=${encodeURIComponent(backUrl)}`;
                                        return;
                                    }
                                    window.location.href = backUrl;
                                } else {
                                    window.location.href = window._ctx + "/";
                                }
                            } else {
                                message.error(res.msg || res.message);
                            }
                        })
                    } else {
                        if (backUrl) {
                            if (sso) {
                                window.location.href = `${window._ctx}/ssowebserver/?backUrl=${encodeURIComponent(backUrl)}`;
                                return;
                            }
                            window.location.href = backUrl;
                        } else {
                            window.location.href = window._ctx + "/";
                        }
                    }
                },
                () => {
                    this.setBtnLoading(false)
                }
            );
        });
    }

    _onSMSVCodeSubmit() {
        this._vcForm.validateFields().then(values => {
            let { originalCode } = this.state;
            if (originalCode) {
                if (originalCode !== values.smsCode) {
                    this.toastFail("您输入的短信验证码不正确！");
                } else {
                    this.showDoingIndicator('登录中...');
                    this.presenter.smsLogin({ ...values }, () => {
                        let { sso, backUrl } = this._urlQuery;
                        if (backUrl) {
                            if (sso) {
                                window.location.href = `${window._ctx}/ssowebserver/?backUrl=${encodeURIComponent(backUrl)}`;
                                return;
                            }
                            window.location.href = backUrl;
                        } else {
                            window.location.href = window._ctx + "/";
                        }
                    });
                }
            } else {
                this.toastFail("验证码失效，请重新发送验证码");
            }
        });
    }

    //3分钟后验证码失效
    _cleanVerifyCode() {
        setTimeout(() => {
            this.setState({ originalCode: undefined });
        }, 180000);
    }


    _onCodeSuccess() {
        this._win.close();
    }

    showDoingIndicator(tip) {
        this.showSpin(tip);
    }

    closeDoingIndicator() {
        this.closeSpin();
    }

    _onVerificationBtnClick() {
        let mobile = this.input.props.value;
        if (!mobile) {
            this.toastFail("手机号码不能为空");
        } else {
            this._win = Window.show(
                <VerificationForm onCancel={() => {
                    this._win.close();
                }}
                    onSMSVCode={this._loadVCode.bind(this)}
                    onCodeSuccess={this._onCodeSuccess.bind(this)}
                />,
                { title: '滑动验证' });
        }
    }

    _loadVCode() {
        let mobile = this.input.props.value;
        if (!mobile) {
            this.toastFail("手机号码不能为空");
        } else {
            this.loginPresenter.checkPhoneNumExist({ mobile }, {}, (result) => {
                let user = result.data.user;
                if (user) {
                    if (this.state.time <= 0) {
                        this.setState({ time: 60 });
                    }
                    this.time();
                    this.setState({ user });
                    this.loginPresenter.sendSmsVerifyCode({ mobile }, {}, (result) => {
                        let resultData = result.data;
                        if (resultData) {
                            this.setState({ originalCode: resultData.verifyCode });
                            this._cleanVerifyCode();
                        }
                    })
                }
            })
        }
    }

    time = () => {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.setState({ time: this.state.time - 1 }, () => {
                if (this.state.time <= 0) {
                    clearInterval(this.timer);
                    return;
                }
                this.time();
            })
        }, 1000)
    };

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    componentDidMount() {
        this.getImg();
    }

    getLocationBackUrl() {
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split("=");
            if (pair[0] === 'backUrl') {
                return pair[1]
            }
        }
    }

    getImg() {
        this.presenter.getImg({}, res => {
            console.log(res);
            if (res.code == 0) {
                this.setState({ img: res.data });
            }
        });
    }

    render() {
        let successUrl = window._ctx;
        let ddQrURL;
        if (window._ddgateway) {
            let backUrl = this.getLocationBackUrl();
            successUrl = backUrl ?? successUrl;
            ddQrURL = window._ddgateway.loginQrCodeUrl({
                rootUrl: window.webRootUrl, backUrl: successUrl, style: "border:none;background-color:#FFFFFF;margin-top:0px"
            });
        }
        let title = "";
        let src = () => {
            let host = "https://sykjinfo.ynshine.com/workbench/login";
            if (window.location.host == "sykjinfo.ynshine.com") {
                host += "?company=shine";
                title = "盛云科技有限公司";
            } else if (window.location.host == "www.ynshine.com") {
                let pathname = window.location.pathname.split("/")[1];
                if (pathname == "cyhy") {
                    host += "?company=cyhy";
                    title = "云南重邮慧云电力工程有限公司";
                }
                if (pathname == "shenglian") {
                    host += "?company=shenglian";
                    title = "昆明盛联消防设施维护管理有限公司";
                }
            } else {
                host = "https://sykjinfo.ynshine.com/wxpctest/workbench/login";
            }
            return 'https://open.weixin.qq.com/connect/qrconnect?appid=wx34cac33bba3abb01&redirect_uri=' +
                encodeURIComponent(host) +
                '&response_type=code&scope=snsapi_login&state='
        }

        if (window.location.host == "sykjinfo.ynshine.com") {
            title = "盛云科技有限公司";
        } else if (window.location.host == "www.ynshine.com") {
            let pathname = window.location.pathname.split("/")[1];
            if (pathname == "cyhy") {
                title = "云南重邮慧云电力工程有限公司";
            }
            if (pathname == "shenglian") {
                title = "昆明盛联消防设施维护管理有限公司";
            }
        } else {
            title = "";
        }

        return (
            <>
                <Script url="http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js" />
                <div className="Login-Page">
                    <div className="login-box bg-white">
                        <div className="pic">
                            <img className="" src={img01} />
                        </div>
                        <div className="con">
                            <Row justify="center" align="middle" className="logo">
                                <Col span={24}>
                                    <Row gutter={8} justify="center" align="middle">
                                        <Col>
                                            <h1>{title}</h1>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={24}>
                                    <h1 className="text-alignC">统一门户</h1>
                                </Col>
                            </Row>
                            <Tabs defaultActiveKey="1" className='login-tabBar' tabBarStyle={{ zIndex: 2 }}>
                                <Tabs.TabPane tab="账户密码登录" key="1">
                                    {
                                        this.state.openid && this.state.wxpcAccessToken && !this.state.token ?
                                            <span style={{ color: "red" }}>*请将微信绑定系统用户</span>
                                            : ""
                                    }
                                    <Form ref={(o) => this.form = o} className="login-form">
                                        <Form.Item name="account" rules={[{ required: true, message: '请输入账号！' }]}>
                                            <Input prefix={<UserOutlined className="site-form-item-icon" />}
                                                placeholder="账户"
                                            />
                                        </Form.Item>
                                        <Form.Item name="pwd" rules={[{ required: true, message: '请输入登录密码！' }]}>
                                            <Input
                                                prefix={<LockOutlined className="site-form-item-icon" />}
                                                type="password"
                                                placeholder="密码"
                                            />
                                        </Form.Item>
                                        <Form.Item name="code"
                                            rules={[{ required: true, message: '请输入登验证码！' }]}
                                            style={{ width: "calc(100% - 120px)", display: 'inline-block' }}
                                        >
                                            <Input

                                                prefix={<SafetyOutlined className="site-form-item-icon" />}
                                                placeholder="验证码"
                                            />
                                        </Form.Item>
                                        <img
                                            style={{ height: 40, position: "relative", marginLeft: 13 }}
                                            src={'data:image/png;base64,' + this.state.img.image}
                                            onClick={() => {
                                                this.getImg();
                                            }}
                                        />
                                        <Form.Item>
                                            <Button type="primary" loading={this.state.loading} htmlType="submit"
                                                className="login-form-button"
                                                onClick={this._onSubmit.bind(this)}>
                                                登录
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                    <div style={{ textAlign: 'center' }}><Link to="/change/newPassword">忘记密码</Link></div>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="钉钉扫码登录" key="2">
                                    <div id="login_container" style={{ transform: 'scale(0.9)', zIndex: 1 }} className="margin-bottom">
                                        <iframe
                                            id="dingQrIframe"
                                            style={{
                                                border: 0,
                                                width: '300px',
                                                height: '300px',
                                                padding: 0,
                                                margin: 0,
                                                marginTop: '-45px'
                                            }}
                                            src={ddQrURL}
                                        />
                                    </div>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="微信扫码登录" key="3">
                                    <div id="wx_login_container" style={{
                                        transform: 'scale(0.9)',
                                        zIndex: 1,
                                        width: 300,
                                        height: 285,
                                        overflow: 'hidden',
                                        position: "relative",
                                        top: -30
                                    }} className="margin-bottom">
                                        <iframe
                                            id="dingQrIframe"
                                            style={{
                                                border: 0,
                                                width: '300px',
                                                height: '400px',
                                                padding: 0,
                                                margin: 0,
                                                marginTop: '-45px',
                                                transform: "scale(0.9)"
                                            }}
                                            src={src()}
                                        />
                                    </div>
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                        {/* <a href="#!" title="点击更换验证码">
                            <img src="http://localhost:7012/ssoapi/captcha/image" width="85%"/>
                        </a> */}
                    </div>
                </div>
            </>

        )
    }
    setBtnLoading(loading) {
        this.setState({ loading })
    }
}
